import React, {useEffect} from "react";
import {AdvancedMarker, InfoWindow, useAdvancedMarkerRef, useMap} from "@vis.gl/react-google-maps";
import MapPin from "../../icons/MapPin";
import addressHTML from "../../../components/addressHTML";

const MapPointers = (props) => {

  const {
    setPopupOpen,
    setSelectedStockist,
    setActiveStockist,
    activeStockist,
    stockists,
    bounds
  } = props;

  const map = useMap();
  const [markerRef, marker] = useAdvancedMarkerRef();


  useEffect(() => {
    if (map && bounds) {
      map.fitBounds(bounds);
    }
  }, [bounds, map, stockists])

  return <>
    {stockists.map((stockist, index) => {
      if (stockist.latitude && stockist.longitude) {
        return <AdvancedMarker
          ref={(activeStockist && activeStockist.id === stockist.id) ? markerRef : null}
          position={{
            lat: parseFloat(stockist.latitude),
            lng: parseFloat(stockist.longitude)
          }}
          key={stockist.id}
          onClick={() => {
          }}
        >
          <div
            onMouseEnter={() => {
            setActiveStockist(stockist)
          }}>
            <MapPin />
          </div>
          {(activeStockist && activeStockist.id === stockist.id) && <InfoWindow
            anchor={marker}
          >
            <div className={'enquire-product__distributor__iw'}>
              <h4>{activeStockist.title}</h4>
              <p dangerouslySetInnerHTML={{ __html: addressHTML(activeStockist) }} />
              <p>
                <button
                  className="btn btn--black enquire-product__distributor__contact"
                  onClick={() => {
                    setSelectedStockist(stockist);
                    setPopupOpen(true);
                  }}>Contact</button>
              </p>
            </div>
          </InfoWindow>}

        </AdvancedMarker>
      }
      return null;
    })}
  </>

}

export default MapPointers;
